module.exports = ".whiteDisabled.disabled:after {\r\n\tbackground: #FFF;\r\n}"